import { isObjEqual, type } from '../utils/assist'
import Tab from './tab'

// 空函数
function noop(){}

// 标签页管理
function TabManager(options) {
    this.init(options)
}

// methods
Object.assign(TabManager.prototype, {
    init(options = {}) {
        this.options = Object.assign({}, TabManager.options, options)

        var { Vue } = this.options

        this.tabs = []
        this.state = Vue.observable({
            cacheList: [],
        })
    },

    // 记录已访问路由
    record(to, from, isReplace) {
        var mode = this.options.mode,
            VTK = this.options.VTK,
            tabs = this.tabs

        var rKey = this.getRouteKey(to)

        // 页签式
        if (mode == "tab") {
            // same tab
            if (tabs.find(v => v.key == rKey)) {
                return rKey
            }

            // add tab
            var old = tabs.findIndex(v => {
                return v.origin.path == to.path &&
                    isObjEqual({ ...v.origin.query, [VTK]: null }, { ...to.query, [VTK]: null })
            })

            if (old >= 0) {
                tabs.splice(old, 1)
            }

            this.forward(this.createTab(to))
        }

        // 线性缓存
        if (mode == "line") {
            var tab = this.createTab(to)

            if (isReplace) {
                this.replace(tab)
            } else {
                const toIndex = tabs.findIndex(v => v.key == rKey)
                if (toIndex === -1) {
                    this.forward(tab)
                } else if (toIndex < tabs.length - 1) {
                    this.back(tabs.length - 1 - toIndex)
                }
            }
        }

        return rKey
    },

    // 创建tab
    createTab(to) {
        // 尝试获取路由组件名称
        var target = to.matched[to.matched.length - 1],
            componentName = target.components.default && target.components.default.name || "VueComponent"

        // push tab
        return new Tab({
            tabManager: this,
            key: this.getRouteKey(to),
            componentName,
            origin: to,
        })
    },

    // 前进
    forward(tab) {
        this.tabs.push(tab)
        this.updateCacheList()
    },

    // 后退
    back(num) {
        this.tabs.splice(this.tabs.length - num, num)
        this.updateCacheList()
    },

    // 替换
    replace(tab) {
        this.tabs.splice(this.tabs.length - 1, 1, tab)
        this.updateCacheList()
    },

    // 清空
    clear() {
        this.tabs.splice(0, this.tabs.length)
        this.updateCacheList()
    },

    // 更新可缓存列表
    updateCacheList() {
        var tabNames = this.tabs.map(t => t.componentName),
            list = [],
            map = {}

        // CompoentName去重（因为动态路由导致）
        tabNames.forEach(name => {
            if (!map[name]) {
                list.push(name)
                map[name] = true
            }
        })

        this.state.cacheList = list
    },

    // 是否已缓存
    isCache(route) {
        var rKey = this.getRouteKey(route)

        return this.tabs.findIndex(v => v.key == rKey && v.cached) >= 0
    },

    // 获取tab
    getTab(key) {
        return this.tabs.find(v => v.key == key)
    },

    // tab间通信
    postMessage(sourceTab, message, targetOrigin, answerOrigin) {
        var targets = []

        // origin 过滤
        if (targetOrigin == "*") {
            targets = this.tabs.filter(v => v !== sourceTab)
        } else {
            // String匹配（path或者name）
            if (type(targetOrigin) == "string") {
                targets = this.tabs.filter(v => v !== sourceTab &&
                    (v.origin.name == targetOrigin || v.origin.path == targetOrigin))
            }

            // Regex匹配（仅限path）
            if (type(targetOrigin) == "regExp") {
                targets = this.tabs.filter(v => v !== sourceTab &&
                    targetOrigin.test(v.origin.path))
            }

            // Object匹配 { path, name, query, params }
            if (type(targetOrigin) == "object") {
                targets = this.tabs.filter(v => v !== sourceTab &&
                    routeMatch(targetOrigin, v.origin))
            }
        }

        var answer = answerOrigin || noop,
            wait = 1000

        if (type(answer) == "object") {
            answer = answerOrigin.handler || noop
            wait = answerOrigin.wait || 1000
        }

        // 无可应答者
        if (targets.length <= 0) {
            return answer(new Error("no reciever"))
        }

        // 无回复
        var timeoutError = new Error("timeout " + wait + "ms"),
            sendTime = new Date().getTime()

        var afterWait = setTimeout(() => {
            afterWait = null
            answer(timeoutError)
        }, wait)

        // notify
        targets.forEach(t => t.notify({
            message,
            origin: sourceTab.origin,
            answer: function(...payload) {
                var now = new Date().getTime()

                if (afterWait) {
                    clearTimeout(afterWait)
                }

                // 超时应答
                if (now - sendTime > wait) {
                    return answer(timeoutError)
                }

                answer(null, ...payload)
            },
        }))
    },

    // 获取路由唯一标识
    getRouteKey(route) {
        return `${route.name || route.path}?${route.query[this.options.VTK]}`
    },
})

// static
TabManager.options = {
    VTK: "_VTK_",
    defaultCache: false, // 路由是否默认缓存
}

var optionMode = "tab" // tab: 页签式缓存； line: 线性缓存（前进刷新，后退不刷新）
Object.defineProperty(TabManager.options, "mode", {
    enumerable: true,
    configurable: false,
    get() {
        return optionMode
    },
    set(val) {
        if (['tab', 'line'].indexOf(val) < 0) {
            throw new Error("AliveTabe参数mode只能为‘tab’或者‘line’")
        }

        optionMode = val
    }
})

export default TabManager